// extracted by mini-css-extract-plugin
export var dividerLine = "_77-3";
export var itemImage = "_77-9";
export var lightDivider = "_77-4";
export var modalContent = "_77-5";
export var modalContentCompact = "_77-6";
export var productCard = "_77-a";
export var productImage = "_77-b";
export var productImageCompact = "_77-7";
export var productImagePlaceholder = "_77-c";
export var productImagePlaceholderCompact = "_77-8";
export var progressBarBackground = "_77-1";
export var progressBarContainer = "_77-0";
export var progressBarFill = "_77-2";